import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AuthCallback = () => {
  const { exchangeSession } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from hash or pre-captured global
      let sessionId = window.__TASKMASTER_PENDING_SESSION;
      if (sessionId) {
        delete window.__TASKMASTER_PENDING_SESSION;
      } else {
        const match = window.location.href.match(/[#&?]session_id=([a-f0-9-]+)/i);
        if (match) sessionId = match[1];
      }

      // Clean hash from URL
      if (window.location.hash) {
        window.history.replaceState(null, '', window.location.pathname);
      }

      if (sessionId) {
        try {
          await exchangeSession(sessionId);
          navigate('/dashboard', { replace: true });
          return;
        } catch (error) {
          console.error('Auth callback exchange failed:', error);
        }
      }

      // If exchange failed or no session_id, go to landing
      navigate('/', { replace: true });
    };

    processAuth();
  }, [exchangeSession, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
        <p className="mt-4 text-slate-600">Signing in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
